import { type ShippingMethodConstructor } from '../../entities/ShippingMethod'
import { type ShippingMethodApiModel } from '../api-models/ShippingMethodApiModel'

export const mapShippingMethodApiModel = (
  data: ShippingMethodApiModel
): ShippingMethodConstructor => ({
  id: data.id,
  name: data.name,
  description: data.description,
  active: data.active,
})
